import { render, staticRenderFns } from "./blackListDetail.vue?vue&type=template&id=2f776404&"
import script from "./blackListDetail.vue?vue&type=script&lang=ts&"
export * from "./blackListDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports